import { render, staticRenderFns } from "./PartnershipGrantForm.vue?vue&type=template&id=4b10005f"
import script from "./PartnershipGrantForm.vue?vue&type=script&lang=js"
export * from "./PartnershipGrantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports